"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteOrderingReducer = exports.siteOrderingActions = exports.TYPES = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'SiteOrdering';

// アクションタイプ
const TYPES = exports.TYPES = {
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  CHANGE_INIT_SEARCH_CONDITION: PREFIX + 'ChangeInitSearchCondtion',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  SET_IS_RE_SEARCH: PREFIX + 'SetIsReSearch',
  GO_MAIN: PREFIX + 'GoMain',
  GO_DETAIL: PREFIX + 'GoDetail',
  SEND_TARGET: PREFIX + 'SendTarget',
  RESET_PAGING: PREFIX + 'ResetPaging',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CLEAR: PREFIX + 'Clear'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  SEARCH: 'search',
  DETAIL: 'detail'
};
const INIT_CONDITION = Object.freeze({
  kaishaCd: '',
  areaCd: ''
});

// 初期状態
const INIT_STATE = {
  dispContent: '',
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  listWithMap: {
    scrollTop: 0
  },
  searchConditions: _objectSpread({}, INIT_CONDITION),
  fixedConditions: _objectSpread({}, INIT_CONDITION),
  initCondtionComplete: false,
  searchResult: [],
  search: false,
  isReSearch: false,
  detailDispKaishaCd: '',
  detailDispAreaCd: '',
  targetKaishaCd: '',
  targetAreaCd: ''
};

// アクション定義
const siteOrderingActions = exports.siteOrderingActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_INIT_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      results: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_IS_RE_SEARCH]: function () {
    return {
      isReSearch: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DETAIL]: function () {
    return {
      detailDispKaishaCd: arguments.length <= 0 ? undefined : arguments[0],
      detailDispAreaCd: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SEND_TARGET]: function () {
    return {
      targetKaishaCd: arguments.length <= 0 ? undefined : arguments[0],
      targetAreaCd: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_PAGING, TYPES.CLEAR);
const siteOrderingReducer = exports.siteOrderingReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.CHANGE_INIT_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    }),
    initCondtionComplete: true
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.results,
    fixedConditions: _objectSpread({}, state.searchConditions),
    search: false,
    modified: false
  }),
  [TYPES.SET_IS_RE_SEARCH]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    isReSearch: action.payload.isReSearch
  }),
  [TYPES.GO_MAIN]: (state, action) => {
    let searchConditions;
    if (action.payload.search) {
      searchConditions = state.fixedConditions;
    } else {
      searchConditions = state.searchConditions;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.SEARCH,
      search: action.payload.search,
      searchConditions
    });
  },
  [TYPES.GO_DETAIL]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.DETAIL,
      detailDispKaishaCd: action.payload.detailDispKaishaCd,
      detailDispAreaCd: action.payload.detailDispAreaCd
    });
  },
  [TYPES.SEND_TARGET]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      targetKaishaCd: action.payload.targetKaishaCd,
      targetAreaCd: action.payload.targetAreaCd
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);